import "./i18n"; // ✅ MUST BE FIRST

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { installAccessTokenStorageSync } from "./utils/accessTokenState";
import { AuthProvider } from "./contexts/AuthContext";
import { BrandThemeProvider } from "./contexts/BrandThemeContext";
import { TutorThemeCacheProvider } from "./contexts/TutorThemeContext";
import { FeatureAccessProvider } from "./contexts/FeatureAccessContext";
import { SchoolSubscriptionProvider } from "./contexts/SchoolSubscriptionContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import App from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

installAccessTokenStorageSync();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <LanguageProvider>
            <AuthProvider>
              <BrandThemeProvider>
                <SchoolSubscriptionProvider>
                  <FeatureAccessProvider>
                    <TutorThemeCacheProvider>
                      <App />
                    </TutorThemeCacheProvider>
                  </FeatureAccessProvider>
                </SchoolSubscriptionProvider>
              </BrandThemeProvider>
            </AuthProvider>
          </LanguageProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
